(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["busy-footer-mobile"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        // Add dynamic year to mobile footer
        const yearElement = document.getElementById('copyright-year-mobile');
        if (yearElement) {
            const currentYear = new Date().getFullYear();
            yearElement.textContent = currentYear;
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busy-footer"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        // Add dynamic year to footer
        const yearElement = document.getElementById('copyright-year');
        if (yearElement) {
            const currentYear = new Date().getFullYear();
            yearElement.textContent = currentYear;
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busy-logo-section"] && !Shopify.designMode) return;
  try {
    
// Logo Animation Observer - Matches original behavior
(function() {
    const logoElement = document.getElementById('logo');
    const productsSection = document.querySelector('.products-section');
    let logoAnimated = false;

    if (logoElement) {
        const animationObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !logoAnimated) {
                    // Add 800ms delay before starting logo animation (matches original)
                    setTimeout(() => {
                        logoElement.classList.add('animate-logo');
                        logoAnimated = true;
                        
                        // Trigger products animation after logo animation completes
                        setTimeout(() => {
                            if (productsSection) {
                                productsSection.classList.add('animate-products');
                            }
                        }, 100);
                    }, 800);
                }
            });
        }, {
            threshold: 0.3
        });

        animationObserver.observe(logoElement);
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busy-main-content"] && !Shopify.designMode) return;
  try {
    
// Main Content Section Scripts
(function() {
  // Logo and Products Animation Observer
  const logoElement = document.getElementById('logo');
  const productsSection = document.querySelector('.products-section');

  let logoAnimated = false;
  let productsAnimated = false;

  if (logoElement) {
    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target === logoElement && !logoAnimated) {
          setTimeout(() => {
            logoElement.classList.add('animate-logo');
            logoAnimated = true;

            // Trigger products animation after logo animation
            setTimeout(() => {
              if (productsSection && !productsAnimated) {
                productsSection.classList.add('animate-products');
                productsAnimated = true;
              }
            }, 100);
          }, 800);
        }
      });
    }, {
      threshold: 0.3
    });

    animationObserver.observe(logoElement);
  }

  // Product card hover effects
  const productCards = document.querySelectorAll('.product-card:not(.coming-soon)');
  productCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      this.style.transition = 'all 0.4s ease';
    });
  });

  // Intersection observer for fade-in effects
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Observe all sections within center content (except products section which has its own animation)
  document.querySelectorAll('.center-content section').forEach(section => {
    if (!section.classList.contains('products-section') && !section.classList.contains('logo-section')) {
      observer.observe(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["busy-products-section"] && !Shopify.designMode) return;
  try {
    
// Products Section Scripts - Matches original behavior
(function() {
    // Product card hover effects (matches original)
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transition = 'all 0.4s ease';
        });
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
